exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1200px) and (max-width:1439px){.long-search-box[data-v-84e20db6]{width:193px}}", ""]);

// exports
